document.addEventListener('DOMContentLoaded', (): void => {
  import('helpers').then((module) => {
    !module.isProduction && module.esbuildReload()
    module.pageRestore.init()
    module.ui.init()
  })

  document.querySelector<HTMLElement>('.waves') && import('./waves').then((module) => module.default.init())
})
